import { REACHABILITY } from '../../../../graphql/queries/vulnerability';
import useNRQuery from '../../../../graphql/useNRQuery';
import { getAssetIdFromPath } from '../../../../utils/utils';
import ReachabilityComponent from './NRreachability';

function NRReachabilityContainer({ advisoryId, identificationIds, componentName, severityColor }) {
  const assetId = getAssetIdFromPath();

  const [cveReachability, cveReachabilityLoading] = useNRQuery({
    query: REACHABILITY,
    options: { variables: { args: { advisoryId, assetId, identificationIds } }, context: { version: 'v3' } },
    qlObjKey: 'getVulnReachability',
    defaultValue: [],
    transformData: data => {
      return data;
    }
  });

  return (
    <ReachabilityComponent
      componentName={componentName}
      reachabilityData={cveReachability}
      isLoading={cveReachabilityLoading}
      severityColor={severityColor}
    />
  );
}
export default NRReachabilityContainer;
